import get from "lodash/get";
import globalContent from "./globalContent.json";

export const getText = (key) => get(globalContent, key, key);
